<!-- 医生卡片 -->
<template>
  <div class="card" @click="handleClick">
    <div class="content">
      <div class="header z-flex">
        <div class="left">
          <div class="name">
            {{ info.doctorName }}
            <auth-img :src="certification" v-if="info.authStatus === 1" />
          </div>
          <div class="level">
            {{ info.departmentName }}
            <span>{{ info.title }}</span>
          </div>
        </div>
        <div class="right">
          <a-avatar
            class="avatar"
            size="large"
            :src="info.headUrl || head_d"
            shape="square"
            alt="头像"
          />
        </div>
      </div>
      <div class="organization">
        <span class="grade" v-if="info.hospitalLevel">{{ info.hospitalLevel }}</span>
        {{ info.hospitalName }}
      </div>
      <div class="desc goodat">
        <span class="have">擅长：</span>
        {{ info.expertise }}
      </div>
      <div class="desc">
        <span class="have">服务：</span>
        图文问诊
        <span class="appoint">复诊预约</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import head_d from '@/assets/img/chat/head_d.png'
import certification from '@/assets/img/chat/certification.png'
const props = defineProps({
  info: {
    type: Object,
    default: () => {},
    required: true
  }
})

const emit = defineEmits(['select'])

const handleClick = () => {
  emit('select', props.idx)
}
</script>
<style scoped lang="scss">
%light-font {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
%normal-font {
  font-size: 14px;
  font-weight: 400;
  color: #3b3b3b;
}
.card {
  text-align: left;
  border: 1px solid transparent;
  cursor: pointer;
  border-radius: 8px;
  background: #ffffff;

  .content {
    padding: 12px 16px;
  }
  .header {
    // align-items: ;
    margin-bottom: 32px;
    .left {
      .name {
        font-weight: 500;
        font-size: 18px;
        color: #1a1a1a;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-left: 8px;
        }
      }
      .level {
        @extend %light-font;
        span {
          border-left: 1px solid #999999;
          padding-left: 6px;
          margin-left: 4px;
        }
      }
    }
    .right {
      border-radius: 4px;
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
    }
  }
  .organization {
    margin-bottom: 12px;
    @extend %normal-font;
    .grade {
      padding: 2px 4px;
      font-weight: 500;
      font-size: 10px;
      color: #ffffff;
      background: #1890ff;
      border-radius: 4px;
      margin-right: 4px;
    }
  }
  .desc {
    @extend %normal-font;
    overflow: hidden;
    text-overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    &.goodat {
      margin-bottom: 12px;
    }

    .have {
      font-weight: 500;
    }
    .fee {
      color: #f84f4f;
    }
    .appoint {
      border-left: 1px solid #5c5c5c;
      padding-left: 8px;
      margin-left: 8px;
    }
  }
}
</style>
